import { render, staticRenderFns } from "./SkeletonButton.vue?vue&type=template&id=0031bf6c"
import script from "./SkeletonButton.vue?vue&type=script&lang=js"
export * from "./SkeletonButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports